import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import Swiper from 'react-id-swiper';
import HoursOfDay from './HoursOfDay';
import DayOfSchedule from './DayOfSchedule';
import IDHelpers from '../../../../core/helpers/IDHelper';
import DateHelpers from '../../../../core/helpers/DateHelper';
import constants from '../../../../core/constants';
import Spinner from '@/presentation/components/Spinner';

const WrapSliderElement = styled.div`
  width: 100%;
  display: flex;
  height: auto;
`;

const ScheduleGridElement = styled.div`
  background: rgb(255 255 255 / 70%);
  width: 100%;
  display: block;
  overflow: auto;
  // margin-top: 75px;
  margin-top: 0px;
  .scroll {
    width: 100%;
    // height: auto;
    height: calc(100vh - 265px);
    display: flex;
    // overflow-y: hidden;
    overflow-y: scroll;
    position: relative;
  }
  .swiper-container {
    background: var(--background-background-disabled);
  }
  .scroll.pauseScroll {
    overflow-y: hidden;
  }
  .slide-item {
    display: flex;
  }
  .scroll::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background-color: rgb(255 255 255 / 70%);
  }
  .scroll::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }
  .scroll::-webkit-scrollbar-thumb {
    background-color: #b0c0ca;
    border-radius: 10px;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    // margin-top: 27px;
    .scroll {
      overflow-y: hidden;
      height: auto;
    }
  }
`;

const ScheduleGridBody = styled.div`
  display: flex;
  overflow: auto;
  position: relative;
  // margin-top: 105px;
  // ::-webkit-scrollbar {
  //   display: none;
  // }
  .swiper-container {
    width: 100%;
    height: auto;
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    margin-top: 0px;
  }
`;

const ScheduleGrid = (props: any) => {
  const {
    schedule,
    startHour,
    endHour,
    today,
    selectedDate,
    handleOpenModalDetail,
    handleCloseModalDetail,
    handleContentModalDetail,
    handleUpdateDropdown,
    isLoading
  } = props;
  const percent = isMobile ? 100 : 100 / schedule?.length;
  const swiperRef: any = useRef(null);
  const changeDate = (d: any, move: number) => {
    const nd = new Date(d.getTime());
    nd.setDate(nd.getDate() + move);
    return new Date(nd.setHours(0, 0, 0, 0));
  };

  const getContentSlide = () => {
    const eventsDay = (schedule || [])
      .filter((date: any) =>
        DateHelpers.isSameDay(selectedDate.getTime(), date.date.getTime())
      )
      .map((item: any[]) => item)[0];

    const id = eventsDay ? eventsDay.date.getTime() : '';
    const subtag = eventsDay ? (
      <DayOfSchedule
        key={IDHelpers.generateID()}
        meetings={eventsDay.meetings}
        dateEvent={eventsDay}
        handleOpenModalDetail={handleOpenModalDetail}
        handleContentModalDetail={handleContentModalDetail}
        handleCloseModalDetail={handleCloseModalDetail}
        startHour={startHour}
        endHour={endHour}
        percent={percent}
        isLast={false}
        isToday={
          DateHelpers.formatFullDate(today) ===
          DateHelpers.formatFullDate(eventsDay.date)
        }
      />
    ) : (
      <></>
    );
    return (
      <div className="slide-item" key={IDHelpers.generateID()} id={id}>
        <WrapSliderElement className="scroll">
          <HoursOfDay start={startHour} end={endHour} />
          {subtag}
        </WrapSliderElement>
      </div>
    );
  };

  const generateGroupDay = (date: any) => {
    const tomorrow = new Date(date);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const yesterday = new Date(date);
    yesterday.setDate(yesterday.getDate() - 1);
    return [{ content: date }];
  };
  const [slides]: any = useState(generateGroupDay(selectedDate));

  const slideChangeHandler = (swiper: any) => {
    const { previousIndex, activeIndex } = swiper;
    if (previousIndex === 1 && activeIndex === 0) {
      handleUpdateDropdown(changeDate(selectedDate, -1));
    } else if (previousIndex === 1 && activeIndex === 2) {
      handleUpdateDropdown(changeDate(selectedDate, 1));
    }
  };

  const contentSwiper = isMobile ? slides.map(() => getContentSlide()) : '';

  return (
    <ScheduleGridElement>
      {isLoading ? (
        <div style={{ height: '60vh' }}>
          <Spinner />
        </div>
      ) : (
        <ScheduleGridBody>
          {isMobile ? (
            <Swiper
              speed={200}
              resistance
              rebuildOnUpdate
              spaceBetween={40}
              cssMode={false}
              height={1700}
              ref={swiperRef}
              initialSlide={0}
              runCallbacksOnInit={false}
              edgeSwipeDetection="prevent"
              loop
              slideToClickedSlide
              on={{
                slideChange: slideChangeHandler
              }}
            >
              {contentSwiper}
            </Swiper>
          ) : (
            <div className="scroll">
              <HoursOfDay start={startHour} end={endHour} />
              {schedule &&
                schedule.map((date: any, index: number) => {
                  const isLast = index === schedule.length - 1;
                  return (
                    <DayOfSchedule
                      key={IDHelpers.generateID()}
                      startHour={startHour}
                      endHour={endHour}
                      meetings={date?.meetings}
                      percent={percent}
                      isLast={isLast}
                      isToday={
                        DateHelpers.formatFullDate(today) ===
                        DateHelpers.formatFullDate(date.date)
                      }
                      dateEvent={date}
                      handleOpenModalDetail={() => {}}
                      handleContentModalDetail={() => {}}
                      handleCloseModalDetail={() => {}}
                    />
                  );
                })}
            </div>
          )}
        </ScheduleGridBody>
      )}
    </ScheduleGridElement>
  );
};

ScheduleGrid.defaultProps = {};

export default ScheduleGrid;
